import React, { useEffect } from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Scaffold from "../../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../../widget/common/ui/MainContainer";
import SignupPersonalInformationContent from "./SignupPersonalInformationContent";
import SignupPersonalInformationButtons from "./widget/SignupPersonalInformationButtons";
import { SignupPersonalInformationContextProvider } from "../../../../provider/onboarding/signup/personal_information/SignupPersonalInformationContextProvider";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";
import AppConfigService from "../../../../service/app_config/AppConfigService";

const SignupPersonalInformationScreen = () => {
  const type: number = ResponsiveDeviceType();

  // DELETE VSIGNUP VERIFCATION DETAIL
  useEffect(() => {
    SessionStorage.deleteValue(StorageKeys.signup_verification_detail);
  }, []);

  return (
    <SignupPersonalInformationContextProvider>
      <Scaffold
        appBarTitle={
          type === 3 ? undefined : AppConfigService.get("company_name")
        }
        bottomNavigationButton={<SignupPersonalInformationButtons />}
      >
        <MainBodyContainer>
          <SignupPersonalInformationContent type={type} />
        </MainBodyContainer>
      </Scaffold>
    </SignupPersonalInformationContextProvider>
  );
};

export default SignupPersonalInformationScreen;
export const routeName: string = "/signup/personal-information";
